/*
 * Detects whether the page is being loaded on a mobile device (phone/tablet)
 * as opposed to a desktop PC. Runs before any scene code is loaded.
 */
export default function isMobileDevice() {
  // Modern API: Chromium-based browsers expose this directly. Only trust a
  // positive answer — Android tablets (and some emulations) report
  // mobile:false here, so fall through to other heuristics otherwise.
  if (navigator.userAgentData && navigator.userAgentData.mobile === true) {
    return true
  }

  const ua = navigator.userAgent || ''

  // iPadOS 13+ reports a Macintosh UA but has touch support
  const isIpadOs = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1

  const isMobileUa =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Tablet/i.test(ua)

  // Fallback: coarse pointer + touch usually means a handheld device
  const isCoarseTouch =
    window.matchMedia &&
    window.matchMedia('(pointer: coarse)').matches &&
    navigator.maxTouchPoints > 0

  return isIpadOs || isMobileUa || isCoarseTouch
}
